import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	background: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		zIndex: 1,
	},
	createButtons: {
		marginBottom: 16,
	},
	ghostCalendarButton: {
		height: 132,
		position: 'relative',
		zIndex: 0,
		overflow: 'hidden',
	},
});
